module.exports = __webpack_public_path__ + "static/media/fuel4.977669de.svg";